import { useEffect } from "react";

export const SITE_URL = "https://drivonsmarket.com";

function upsert(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export default function Seo({ title, description, path, noindex = false }) {
  useEffect(() => {
    const url = `${SITE_URL}${path === "/" ? "/" : path}`;
    const image = `${SITE_URL}/images/og-image.jpg`;
    document.title = title;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, follow" : "index, follow" });
    upsert('link[rel="canonical"]', { rel: "canonical", href: url });
    upsert('meta[property="og:type"]', { property: "og:type", content: "website" });
    upsert('meta[property="og:site_name"]', { property: "og:site_name", content: "Drivons Market" });
    upsert('meta[property="og:title"]', { property: "og:title", content: title });
    upsert('meta[property="og:description"]', { property: "og:description", content: description });
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
    upsert('meta[property="og:image"]', { property: "og:image", content: image });
    upsert('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsert('meta[name="twitter:image"]', { name: "twitter:image", content: image });
  }, [title, description, path, noindex]);
  return null;
}
